import {SuperBit_swaggerClient} from './superbit-api-models'
import {IDNameDescriptionItem,IDNameDescriptionDictionary,AutocompleteData} from './Site'


export class ManulApiModel extends SuperBit_swaggerClient {

    private _http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };

    constructor(http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super("",http);

        this._http = http ? http : <any>window;
        
    }

    GetGovBanks(): Promise<[]> {
        let newUrl_ = "https://data.gov.il/api/3/action/datastore_search?resource_id=1c5bc716-8210-4ec7-85be-92e6271955c2&limit=1000000";

        let url_ = "https://data.gov.il/api/3/action/datastore_search?resource_id=1c5bc716-8210-4ec7-85be-92e6271955c2&limit=1000000";
        
            newUrl_ = newUrl_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        

        return this._http.fetch(newUrl_, options_).then((_response: Response) => {
            return this.processBanks(_response);
        });
    }


    GetGovData1(licenseNumber: string | undefined): Promise<GovData1> {
        try {
            let url_ = "https://data.gov.il/api/3/action/datastore_search?resource_id=053cea08-09bc-40ec-8f7a-156f0677aff3&";
            if (licenseNumber === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (licenseNumber !== undefined)
                url_ += "filters=" + encodeURIComponent('{"mispar_rechev": ' + licenseNumber + '}') ;
        
                url_ = url_.replace(/[?&]$/, "");

            let options_ = <RequestInit>{
                method: "GET",
                headers: {
                    "Accept": "text/plain"
                }
            };
            
            return this._http.fetch(url_, options_).then((_response: Response) => {
                return this.processGetGovData1(_response);
            });
            
        } catch (error) {
            console.error("Error in GetGovData1:", error);
            return Promise.resolve<GovData1>(<any>null);
        }
        
    }
    protected processBanks(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                var rivchitBanks = [1, 2, 4, 7, 8, 9, 10, 11, 12, 13, 14, 17, 18, 19, 20, 24, 26, 28, 31, 32, 34, 35, 46, 47, 52, 53, 54, 99];
                var banks = resultData200.result.records;

                var _banks = banks.filter((x:any)=>rivchitBanks.includes(x.Bank_Code));
                _banks.push({"Bank_Code":9,"Bank_Name":"בנק הדואר","Branch_Code":1,"Branch_Name":"סניף ראשי","City":"ישראל"});
                return _banks;
            //return banks.filter((x:any)=>rivchitBanks.includes(x.Bank_Code));
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }
    protected processGetGovData1(response: Response): Promise<GovData1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GovData1.fromJS(resultData200);
                
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GovData1>(<any>null);
    }

    GetCities(): Promise<AutocompleteData[]> {
        try{
            let url_ = "https://data.gov.il/api/3/action/datastore_search?resource_id=5c78e9fa-c2e2-4771-93ff-7f400a12f7ba&limit=1000000";
        
            
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            

            let options_ = <RequestInit>{
                method: "GET",
                
            };

            return this._http.fetch(url_, options_).then((_response: Response) => {
                
                return this.processCities(_response);

            });
        }catch(error){
            console.error("Error fetching cities:", error);
            return Promise.resolve<AutocompleteData[]>([]);
        }
    }
    

    protected processCities(response: Response): Promise<AutocompleteData[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                var cities = [];
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                let records = resultData200.result.records;
                
                if (records.length > 0) {
                    for(var i=0;i<records.length;i++){
                        var city = new AutocompleteData();
                        city.label = records[i].שם_ישוב;
                        city.val = records[i].שם_ישוב;
                        cities.push(city);
                    }
                    
    
                }


            return cities;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutocompleteData[]>(<any>null);
    }

    

    GetStreetsByCity(city:string): Promise<AutocompleteData[]> {
        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        var raw = JSON.stringify({
          "resource_id": "9ad3862c-8391-4b2f-84a4-2d4c68625f4b",
          "filters": {
            "סמל_ישוב": "8400 "
          },
          "limit": 1000000
        });
        
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw
        };
        
        return fetch("https://data.gov.il/api/3/action/datastore_search", requestOptions)
        .then((_response: Response) => {
            
            return this.processCities(_response);

        }).catch(error => {
            console.log('error', error);
            return Promise.resolve<AutocompleteData[]>([]);
        });

        

    }

    protected processStreetsByCity(response: Response): Promise<AutocompleteData[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                
                var cities = [];
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                let records = resultData200.result.records;
                
                if (records.length > 0) {
                    for(var i=0;i<records.length;i++){
                        var city = new AutocompleteData();
                        city.label = records[i].שם_ישוב;
                        city.val = records[i].שם_ישוב;
                        cities.push(city);
                    }
                    
    
                }


            return cities;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutocompleteData[]>(<any>null);
    }

    GetGovData2(degem_nm: string | undefined,shnat_yitzur: number | undefined,degem_cd: string | undefined): Promise<GovData2> {
        try {
        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");


        
        
        
        
        
        let url_ = "https://data.gov.il/api/3/action/datastore_search";

        if(degem_nm!=null && shnat_yitzur!=null && degem_cd!=null){
            
            var body = JSON.stringify({
                "resource_id": "142afde2-6228-49f9-8a29-9b6c3a0cbe40",
                "filters": "{\"degem_nm\": \""+ degem_nm +"\",\"shnat_yitzur\":\""+ shnat_yitzur +"\",\"degem_cd\":\""+ degem_cd +"\"}"
              });

              
            const content_ = JSON.stringify(body);
    
            let options_ = <RequestInit>{
                body: body,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers":"content-type",
                    "Access-Control-Allow-Methods":"POST, GET, OPTIONS, PUT"
                }
            };
    
            return this._http.fetch(url_, options_).then((_response: Response) => {
                
                return this.processSimulatorUpdateLeadCalcDetails(_response);

            });

            
            
        }
        else{throw new Error("Parameters cannot be null.");}
            
        } catch (error) {
            console.error("Error in GetGovData2:", error);
            return Promise.resolve<GovData2>(<any>null);
        }
    }

    protected processGetGovData2(response: Response): Promise<GovData2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GovData2.fromJS(resultData200);
                
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GovData2>(<any>null);
    }


    GetGovData3(tozeret: string | undefined,degem: string | undefined): Promise<GovData2> {
        
        try {
            
        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");


        
        

        let url_ = `https://data.gov.il/api/3/action/datastore_search?resource_id=142afde2-6228-49f9-8a29-9b6c3a0cbe40&filters=%7B%22tozeret_cd%22%3A%20%22${tozeret}%22%2C%22degem_cd%22%3A%20%22${degem}%22%7D`;

        if(tozeret!=null && degem!=null){



            let options_ = <RequestInit>{
                method: "GET",
                headers: {
                }
            };
            return this._http.fetch(url_, options_).then((_response: Response) => {
                
                return this.processGetGovData2(_response);
            });


            
            
        }
        else{throw new Error("Parameters cannot be null.");}

        } catch (error) {
            console.error("Error in GetGovData3:", error);
            return Promise.resolve<GovData2>(<any>null);
            
        }
        

            
    }

    
    GetGovData4(tozeret: string | undefined,degem: string | undefined,year:number): Promise<GovData2> {

        try {
            
        
        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");


        
        
let url_ = `https://data.gov.il/api/3/action/datastore_search?resource_id=142afde2-6228-49f9-8a29-9b6c3a0cbe40&filters=%7B%22tozeret_cd%22%3A%20%22${tozeret}%22%2C%22degem_cd%22%3A%20%22${degem}%22%2C%22shnat_yitzur%22%3A%20${year}%7D`

        if(tozeret!=null && degem!=null){



            let options_ = <RequestInit>{
                method: "GET",
                headers: {
                }
            };
            return this._http.fetch(url_, options_).then((_response: Response) => {
                
                return this.processGetGovData2(_response);
            });


            
            
        }
        else{throw new Error("Parameters cannot be null.");}
        } catch (error) {
            console.error("Error in GetGovData4:", error);
            return Promise.resolve<GovData2>(<any>null);
            
        }
            
    }

    
    GetGarages(): Promise<any[]> {

        try {

            let url_ = "https://data.gov.il/api/3/action/datastore_search?resource_id=bb68386a-a331-4bbc-b668-bba2766d517d&limit=1000000";
        
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let options_ = <RequestInit>{
                method: "GET",
            };

            return this._http.fetch(url_, options_).then((_response: Response) => {
                return this.processGetGarages(_response);
            });
        } catch (error) {
            console.error("Error in GetGarages:", error);
            return Promise.resolve<any[]>([]);
        }
    }
    

    protected processGetGarages(response: Response): Promise<any[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                var garages = [];
                // let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                let records = resultData200.result.records;
                records = this.removeDuplicates(records, 'mispar_mosah');
                records.sort((a: any, b: any) => b.shem_mosah > a.shem_mosah);
                // if (records.length > 0) {
                //     for(var i=0;i<records.length;i++){
                //         var city = new AutocompleteData();
                //         city.label = records[i].שם_ישוב;
                //         city.val = records[i].שם_ישוב;
                //         garages.push(city);
                //     }
                // }
                return records;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any[]>(<any>null);
    }
    removeDuplicates = (array: any[], key: string) => {
        return array.filter((item, index, self) =>
            index === self.findIndex(obj => obj[key] === item[key])
        );
    };
}



export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export class GovData1  {
    VehicleOwnership?: number | undefined;
    Color?: string | undefined;
    shnat_yitzur?:number | undefined;
    EntryToRoadDate?:Date | undefined;
    degem_nm?: string | undefined;
    degem_cd?: string | undefined;
    

    constructor(data?: GovData1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            
            if (_data.result.records.length > 0) {
                var vehicle = _data.result.records[0];

                if (vehicle.baalut == "פרטי") { 
                    this.VehicleOwnership = 0;
                     }
                        else { this.VehicleOwnership = 1; }


            this.Color = vehicle.tzeva_rechev;
            this.shnat_yitzur = vehicle.shnat_yitzur;
            if (vehicle.moed_aliya_lakvish!=null && vehicle.moed_aliya_lakvish.length > 0 ) {
                var year = vehicle.moed_aliya_lakvish.substring(0, 4);
                var month = vehicle.moed_aliya_lakvish.substring(5);
                this.EntryToRoadDate = new Date(year,month,1);
            }
            else {
                if(this.shnat_yitzur!=null)
                this.EntryToRoadDate  = new Date(this.shnat_yitzur,1,1);
            }
this.degem_nm = vehicle.degem_nm;
this.degem_cd = vehicle.degem_cd;


        }
    }
}

    static fromJS(data: any): GovData1 {
        data = typeof data === 'object' ? data : {};
        let result = new GovData1();
        result.init(data);
        return result;
    }

    
}

export class GovData2  {
    VehicleOwnership?: number | undefined;
    Color?: string | undefined;
    shnat_yitzur?:number | undefined;
    EntryToRoadDate?:Date | undefined;
    degem_nm?: string | undefined;
    degem_cd?: string | undefined;
    tozar?: string | undefined;
    kinuy_mishari?: string | undefined;
    merkav?: string | undefined;
    ramat_gimur?: string | undefined;
    hanaa_nm?: string | undefined;
    nefah_manoa?: string | undefined;
    technologiat_hanaa_nm?: string | undefined;
    

    constructor(data?: GovData1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            
            if (_data.result.records.length > 0) {
                var vehicle = _data.result.records[0];

                if (vehicle.baalut == "פרטי") { 
                    this.VehicleOwnership = 0;
                     }
                        else { this.VehicleOwnership = 1; }


            this.Color = vehicle.tzeva_rechev;
            this.shnat_yitzur = vehicle.shnat_yitzur;
            if (vehicle.shnat_yitzur!=null && vehicle.shnat_yitzur.length > 0) {
                var year = vehicle.shnat_yitzur.substring(0, 4);
                var month = vehicle.shnat_yitzur.substring(5);
                this.EntryToRoadDate =new Date(year,month,1);
            }
            else {
                if(this.shnat_yitzur!=null)
                    this.EntryToRoadDate  = new Date(this.shnat_yitzur,1,1);
            }
            this.degem_nm = vehicle.degem_nm;
            this.degem_cd = vehicle.degem_cd;
            this.tozar = vehicle.tozar;
            this.kinuy_mishari = vehicle.kinuy_mishari;
            this.merkav = vehicle.merkav;
            this.ramat_gimur = vehicle.ramat_gimur;
            this.hanaa_nm = vehicle.hanaa_nm;
            this.nefah_manoa = vehicle.nefah_manoa;
            this.technologiat_hanaa_nm = vehicle.technologiat_hanaa_nm;
        }
    }
}

    static fromJS(data: any): GovData1 {
        data = typeof data === 'object' ? data : {};
        let result = new GovData2();
        result.init(data);
        return result;
    }
}






